function toStringMap(raw: unknown): Record<string, string> {
  const out: Record<string, string> = {};
  if (!raw || typeof raw !== 'object') return out;
  if (Array.isArray(raw)) {
    raw.forEach((item) => {
      if (!item || typeof item !== 'object') return;
      const row = item as Record<string, unknown>;
      const key = String(row.tgkey ?? row.keyword ?? row.key ?? '').trim();
      if (key.length < 2) return;
      out[key] = String(row.tgvalue ?? row.replace_value ?? row.value ?? '');
    });
    return out;
  }
  Object.entries(raw as Record<string, unknown>).forEach(([k, v]) => {
    if (!k || k === 'partial' || k === 'full' || k === 'list' || k === 'data' || k === 'code' || k === 'msg' || k === 'time') {
      return;
    }
    if (v == null) return;
    if (typeof v === 'object') return;
    out[String(k)] = String(v);
  });
  return out;
}

export function parseYdymKeywordsPayload(raw: any): { partial: Record<string, string>; full: Record<string, string> } {
  let root = raw;
  if (typeof raw === 'string') {
    try {
      root = JSON.parse(raw);
    } catch {
      return { partial: {}, full: {} };
    }
  }
  if (root && typeof root === 'object' && root.data !== undefined) {
    root = typeof root.data === 'string' ? (() => {
      try {
        return JSON.parse(root.data);
      } catch {
        return root.data;
      }
    })() : root.data;
  }
  const inner = (root && typeof root === 'object' && (root.list || root)) || {};
  let partial = toStringMap(inner?.partial);
  let full = toStringMap(inner?.full);
  if (!Object.keys(partial).length && !Object.keys(full).length) {
    const legacy = toStringMap(inner);
    partial = legacy;
  }
  return { partial, full };
}
